import {
  LIST_VARIAVEIS_INIT,
  LIST_VARIAVEIS_SUCCESS,
  CREATE_VARIAVEL_INIT,
  CREATE_VARIAVEL_SUCCESS,
  UPDATE_VARIAVEL_INIT,
  UPDATE_VARIAVEL_SUCCESS,
  DELETE_VARIAVEL_INIT,
  DELETE_VARIAVEL_SUCCESS,
  VARIAVEIS_ERROR_MSG,
  CLEAR_FLAGS_VARIAVEIS
} from '../actionTypes';
import { IVariavel } from 'src/integracoes/servicos/mongo-atlas/modelos/IVariavel';

const INIT_STATE = {
  variaveis: [] as IVariavel[],
  loading: false,
  loadingSave: false,
  isUpdated: false,
  isError: false,
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_VARIAVEIS_INIT:
      return { ...state, loading: true, isError: false, msg: '' };
    case LIST_VARIAVEIS_SUCCESS: {
      const { variaveis } = action.payload;
      return { ...state, loading: false, variaveis };
    }
    case CREATE_VARIAVEL_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case CREATE_VARIAVEL_SUCCESS: {
      const { variavel } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, variaveis: [...state.variaveis, variavel] };
    }
    case UPDATE_VARIAVEL_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case UPDATE_VARIAVEL_SUCCESS: {
      const { variavel } = action.payload;
      return {
        ...state,
        loadingSave: false,
        isUpdated: true,
        variaveis: state.variaveis.map((v) => (v.id === variavel.id ? variavel : v))
      };
    }
    case DELETE_VARIAVEL_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case DELETE_VARIAVEL_SUCCESS: {
      const { id } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, variaveis: state.variaveis.filter((v) => v.id !== id) };
    }
    case VARIAVEIS_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, loadingSave: false, isError: true, msg };
    }
    case CLEAR_FLAGS_VARIAVEIS:
      return { ...state, isUpdated: false, isError: false, loadingSave: false, msg: '' };
    default:
      return { ...state };
  }
};
